import {
  createErrorResult,
  DriverApi,
  errors,
  Log,
  RydeUiUnit,
  SimpleResult,
  SystemManagersApi,
} from "@ryde/shared";

export type TResetPasswordAPIFunction = (
  entityId: number,
  abortController?: AbortController,
) => Promise<SimpleResult<void> | undefined>;

export const resetPasswordAPIMap: Partial<
  Record<RydeUiUnit, TResetPasswordAPIFunction>
> = {
  systemManager: SystemManagersApi.resetPassword,
  driver: DriverApi.resetPassword,
};

export const getResetPasswordAPIFunction = (
  entity: RydeUiUnit,
): TResetPasswordAPIFunction => {
  if (resetPasswordAPIMap[entity]) {
    return resetPasswordAPIMap[entity];
  }

  return async () => {
    Log.error(`Api method not found for unit ${entity}`);
    return createErrorResult(errors.common.unknownError);
  };
};
